import has  from 'lodash/has';

export default {
    attributeOptionsSkills(state) {
        return state.attributeOptions.filter(o => o.attribute_code === 'skills');
    },

    attributeOptionsPerks(state) {
        return state.attributeOptions.filter(o => o.attribute_code === 'perks');
    },

    attributeOptionsCertifications(state) {
        return state.attributeOptions.filter(o => o.attribute_code === 'certifications');
    },

    attributeOptionsEducation(state) {
        return state.education;
    },

    attributeOptionsReference(state) {
        return state.reference;
    },

    attributeOptionsWorkExperience(state) {
        return state.workExperience;
    },

    avatar(state) {
        return has(state.user, 'avatar.src') ? state.user.avatar : {};
    },

    defaultResume(state) {
        return state.resumes.find(o => o.is_default) || {};
    },
};
